import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index';
import store from './store';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import component from './components';
import { createI18n } from 'vue-i18n'
import { lang_cn } from "./assets/language/cn.js";
import { lang_en } from "./assets/language/en.js";
import { lang_ja } from "./assets/language/ja.js";
import { lang_zh_TW } from "./assets/language/zh-TW.js";
import VueEasyLightbox from 'vue-easy-lightbox';
import 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css';

const messages = {
    // cn: lang_cn,
    // en: lang_en,
    // ja: lang_ja,
    // zh_TW: lang_zh_TW
}


const i18n = createI18n({
    locale: 'cn',
    fallbackLocale: 'en',
    legacy: false,
    messages
})
export default i18n
import ElementPlus, {ElMessageBox} from 'element-plus'

// 引入 Element Plus 默认样式文件
import 'element-plus/theme-chalk/index.css'
const app = createApp(App);

app.use(router);
app.use(store)
app.use(ElementPlus)
app.use(component);
app.use(i18n);
app.component('VueDatePicker', VueDatePicker);
app.component('VueEasyLightbox', VueEasyLightbox);

app.mount("#app");

